/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import Accordion from '../../../../components/Accordion';
import Table, { ColumnDefinitionType } from '../../../../components/Table';
import { Link } from 'react-router-dom';
import { DocumentoHabilitacion } from '../../../../types/DocumentoHabilitacion';
import { DocumentoContratista } from '../../../../types/DocumentoContratista';
import { useDocumentoHabilitacion } from '../../../../hooks/useDocumentoHabilitacion';
import { useHabilitacionContratista } from '../../../../hooks/useHabilitacionContratista';
import { useUserLogin } from '../../../../hooks/useUserLogin';
import { useCalificacionHabilitacion } from '../../../../hooks/useCalificacionHabilitacion';
import MyModal from '../../../../components/Modal';
import ObservacionComponent from '../../../../components/Observaciones';
import moment from 'moment';
import { Loading } from '../../../../components/Loading';
import { Button } from 'react-bootstrap';
import { AgregarDocumentoHabilitacion } from './agregar';
import { toast } from 'react-toastify';
import { findAll } from '../../../../services/Service';
import {
    EN_PROCESO_STATUS_ID,
    HAB_REVISION_STATUS_ID,
    HAB_OBSERVADA_STATUS_ID,
    OK_DOCUMENTO_STATUS,
    NO_OK_DOCUMENTO_STATUS,
} from '../../../../constants/constants';

type DocumentacionGeneralProps = {
    isDisabled?: boolean;
    isEdit?: boolean;
    soloLectura?: boolean;
};

const DocumentacionGeneral: React.FC<DocumentacionGeneralProps> = ({
    isDisabled = false,
    isEdit = true,
    soloLectura = false,
}) => {
    const { habilitacionSelected } = useHabilitacionContratista();
    const {
        documentos,
        documentoSelected,
        buscarDocumentosByIdHabilitacion,
        handleDocumentoSelected,
        deleteDocumento,
        visualizarDocumento,
        descargarDocumento,
        loading,
    } = useDocumentoHabilitacion();
    const {
        isEmpresaGestoraTipoUsuario,
        isEmpresaSupervisoraTipoUsuario,
        isContratistaTipoUsuario,
    } = useUserLogin();
    const { calificarDocumento } = useCalificacionHabilitacion();

    const [cargado, setCargado] = useState(false);
    const [isOpenAddDocument, setIsOpenAddDocument] = useState(false);
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
    const [isOpenObservacionModal, setIsOpenObservacionModal] = useState(false);
    const [tiposDocumento, setTiposDocumento] = useState<DocumentoContratista[]>([]);
    const [documentosLocal, setDocumentosLocal] = useState<DocumentoHabilitacion[]>([]);

    const estadoActual = habilitacionSelected.idTipoEstado;
    const puedeCalificar =
        !soloLectura &&
        (isEmpresaGestoraTipoUsuario() || isEmpresaSupervisoraTipoUsuario()) &&
        estadoActual === HAB_REVISION_STATUS_ID;
    const esObservadaContratista =
        isContratistaTipoUsuario() && estadoActual === HAB_OBSERVADA_STATUS_ID;
    const puedeEliminar = !isDisabled && estadoActual === EN_PROCESO_STATUS_ID;

    const toggleAddDocument = () => setIsOpenAddDocument(!isOpenAddDocument);
    const toggleDeleteModal = () => setIsOpenDeleteModal(!isOpenDeleteModal);

    useEffect(() => {
        setDocumentosLocal(documentos);
    }, [documentos]);

    useEffect(() => {
        if (habilitacionSelected.idEmpresaGestora) {
            findAll(
                `documentos-contratista/find?idEmpresaGestora=${habilitacionSelected.idEmpresaGestora}&soloActivos=true`
            ).then((response) => {
                if (response && response.data) {
                    setTiposDocumento(response.data);
                }
            });
        }
    }, [habilitacionSelected.idEmpresaGestora]);

    const handleClick = (
        event: React.MouseEvent<HTMLDivElement, MouseEvent>
    ) => {
        event.preventDefault();
        if (!cargado) {
            buscarDocumentosByIdHabilitacion(habilitacionSelected.id);
            setCargado(true);
        }
    };

    const handleConfirmDeleteDocument = () => {
        deleteDocumento(documentoSelected.id.toString()).then((success) => {
            if (success) {
                toast.success('Documento eliminado correctamente');
                buscarDocumentosByIdHabilitacion(habilitacionSelected.id);
            }
            toggleDeleteModal();
        });
    };

    const onCheckboxChange = (data: DocumentoHabilitacion, status: string) => {
        setDocumentosLocal((prevList) =>
            prevList.map((item) =>
                item.id === data.id ? { ...item, statusDocumento: status } : item
            )
        );
        calificarDocumento(data.id, status, data.observacion ?? '').catch(() => {
            // revertir si falla
            setDocumentosLocal((prevList) =>
                prevList.map((item) =>
                    item.id === data.id
                        ? { ...item, statusDocumento: data.statusDocumento }
                        : item
                )
            );
        });
    };

    const onObservacionChange = (observacion: string) => {
        setIsOpenObservacionModal(false);
        const doc = documentoSelected as unknown as DocumentoHabilitacion;
        const observacionPrevia = doc.observacion;
        setDocumentosLocal((prevList) =>
            prevList.map((item) =>
                item.id === doc.id ? { ...item, observacion } : item
            )
        );
        calificarDocumento(doc.id, doc.statusDocumento ?? '', observacion).catch(() => {
            // revertir si falla
            setDocumentosLocal((prevList) =>
                prevList.map((item) =>
                    item.id === doc.id
                        ? { ...item, observacion: observacionPrevia }
                        : item
                )
            );
        });
    };

    const columnsDocumentoContratista: ColumnDefinitionType<
        DocumentoContratista,
        keyof DocumentoContratista
    >[] = [
        {
            key: 'nombre',
            header: 'Tipo de Documento',
        },
        {
            key: 'obligatorio',
            header: 'Obligatorio',
            customBooleanRender: (value) => (value ? 'Si' : 'No'),
        },
        {
            key: 'fechaEditable',
            header: 'Fecha Venc. Requerida',
            customBooleanRender: (value) => (value ? 'Si' : 'No'),
        },
    ];

    const columns: ColumnDefinitionType<
        DocumentoHabilitacion,
        keyof DocumentoHabilitacion
    >[] = [
        {
            key: 'nombreTipoDocumento',
            header: 'Tipo de Documento',
        },
        {
            key: 'nombreArchivo',
            header: 'Nombre',
        },
        {
            key: 'fechaVencimiento',
            header: 'Vencimiento',
            cell: (data: DocumentoHabilitacion) => {
                const isExpired =
                    data.fechaVencimiento &&
                    moment(data.fechaVencimiento).isBefore(moment(), 'day');
                return (
                    <span style={{ color: isExpired ? 'red' : 'inherit' }}>
                        {data.fechaVencimiento
                            ? moment(data.fechaVencimiento).format('DD/MM/YYYY')
                            : ''}
                    </span>
                );
            },
        },
        {
            key: 'id',
            header: 'Acciones',
            cell: (data: DocumentoHabilitacion) => (
                <>
                    <Link
                        title="Visualizar"
                        to="/exportar"
                        onClick={(e) => {
                            e.preventDefault();
                            visualizarDocumento(data as any);
                        }}
                        target="_blank"
                    >
                        <i
                            className="fa fa-eye text-secondary me-2"
                            aria-hidden="true"
                        ></i>
                    </Link>
                    <Link
                        title="Descargar"
                        to="/exportar"
                        onClick={(e) => {
                            e.preventDefault();
                            descargarDocumento(data as any);
                        }}
                        target="_blank"
                    >
                        <i
                            className="fa fa-arrow-down text-secondary me-2"
                            aria-hidden="true"
                        ></i>
                    </Link>
                    {puedeEliminar && (
                        <a
                            href="#"
                            title="Eliminar"
                            onClick={() => {
                                handleDocumentoSelected(data);
                                toggleDeleteModal();
                            }}
                        >
                            <i
                                className="fa fa-trash text-secondary me-2"
                                aria-hidden="true"
                            ></i>
                        </a>
                    )}
                    {puedeCalificar && (
                        <a
                            href="#"
                            title="Observaciones"
                            onClick={() => {
                                handleDocumentoSelected(data);
                                setIsOpenObservacionModal(true);
                            }}
                        >
                            <i
                                className="fa fa-search text-secondary me-2"
                                aria-hidden="true"
                            ></i>
                        </a>
                    )}
                    {esObservadaContratista && data.observacion && (
                        <a
                            href="#"
                            title="Observaciones"
                            onClick={() => {
                                handleDocumentoSelected(data);
                                setIsOpenObservacionModal(true);
                            }}
                        >
                            <i
                                className="fa fa-search me-2"
                                style={{ color: 'red' }}
                                aria-hidden="true"
                            ></i>
                        </a>
                    )}
                </>
            ),
        },
        {
            key: 'statusDocumento',
            header: '',
            isEnabledCheckStatusDocument: puedeCalificar,
            statusAprobadoValue: OK_DOCUMENTO_STATUS,
            statusNoAprobadoValue: NO_OK_DOCUMENTO_STATUS,
        },
    ];

    return (
        <>
            <MyModal
                isOpen={isOpenObservacionModal}
                toggle={() => setIsOpenObservacionModal(false)}
                title="Observaciones"
                cancelButton={false}
                secondButton={false}
            >
                <ObservacionComponent
                    observacion={documentoSelected.observacion}
                    isEdit={puedeCalificar}
                    saveButtonFn={onObservacionChange}
                    cancelButtonFn={() => setIsOpenObservacionModal(false)}
                    returnButtonFn={() => setIsOpenObservacionModal(false)}
                />
            </MyModal>
            <MyModal
                isOpen={isOpenDeleteModal}
                toggle={toggleDeleteModal}
                title="Advertencia"
                cancelButton={true}
                secondButton={true}
                secondButtonTitle={'Aceptar'}
                titleCancelar={'Cancelar'}
                secondButtonFn={handleConfirmDeleteDocument}
            >
                <label>Confirma la eliminación del registro?</label>
            </MyModal>
            <MyModal
                isOpen={isOpenAddDocument}
                toggle={toggleAddDocument}
                title="Agregar Documento"
                enabledFooter={false}
            >
                <AgregarDocumentoHabilitacion
                    tiposDocumento={tiposDocumento}
                    cancelButtonFn={toggleAddDocument}
                    saveCompletedButtonFn={toggleAddDocument}
                />
            </MyModal>
            <Accordion
                id={'documentacionGeneral'}
                title="Documentación General"
                collapsed={true}
                handleClick={handleClick}
            >
                <div>
                    <div className="p-3">
                        <div className="row">
                            <div className="col-md-12 text-start align-bottom">
                                <span>Documentos Requeridos para la Habilitación</span>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <Table
                                data={tiposDocumento}
                                columns={columnsDocumentoContratista}
                            />
                        </div>
                    </div>
                    <div className="p-3">
                        <div className="row">
                            <div
                                className="col-md-6 text-start align-bottom"
                                style={{ alignSelf: 'flex-end' }}
                            >
                                <span>Documentos Adjuntados</span>
                            </div>
                            <div className="col-md-6 text-end">
                                {!isDisabled && (
                                    <Button
                                        className="btn-secondary"
                                        variant="secondary"
                                        onClick={toggleAddDocument}
                                    >
                                        Agregar Documento
                                    </Button>
                                )}
                            </div>
                        </div>
                        <div className="table-responsive">
                            {loading ? (
                                <Loading />
                            ) : (
                                <Table
                                    data={documentosLocal}
                                    columns={columns}
                                    onCheckboxChange={onCheckboxChange}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </Accordion>
        </>
    );
};

export default DocumentacionGeneral;
